<template>

  <b-row>
    <b-col md="12">

      <!-- Alert: No item found -->
      <b-alert
        variant="danger"
        :show="errorMessage !== ''"
      >
        <h4 class="alert-heading">
          {{ errorMessage }}
        </h4>

      </b-alert>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class=""
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <b-row>
            <!-- Bên trái -->
            <b-col>
              <b-col
                md="12"
                class="row"
              >
                <b-col md="8">
                  <!-- Name -->
                  <b-form-group>
                    <template #label>
                      <label class="d-block font-weight-bolder">Tên tiêu đề <span
                        class="text-danger"
                      >*</span></label>
                    </template>
                    <b-form-input
                      id="name"
                      v-model="itemData.name"
                      readonly
                    />

                  </b-form-group>
                </b-col>
                <b-col md="4">

                  <b-form-group
                    label-for="category_work_id"
                  >
                    <template #label>
                      <label class="d-block font-weight-bolder">Thư mục <span
                        class="text-danger"
                      >*</span></label>
                    </template>
                    <b-form-input
                      id="name"
                      v-model="itemData.folder.name"
                      readonly
                    />

                  </b-form-group>
                </b-col>
              </b-col>
              <b-col
                md="12"
                class="row"
              >
                <b-col md="8">
                  <!-- Mô tả -->
                  <b-form-group>
                    <template #label>
                      <label class="d-block font-weight-bolder">Nội dung </label>
                    </template>
                    <b-form-textarea
                      id="content"
                      v-model="itemData.content"
                      rows="4"
                      readonly
                    />
                  </b-form-group>
                  <b-form-group>
                    <template #label>
                      <label class="d-block font-weight-bolder">Ghi chú </label>
                    </template>
                    <b-form-textarea
                      id="note"
                      v-model="itemData.note"
                      rows="2"
                      readonly
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">

                  <b-form-group
                    label-for="manager_id"
                  >
                    <template #label>
                      <label class="d-block font-weight-bolder">Kênh phát sóng <span
                        class="text-danger"
                      >*</span></label>
                    </template>
                    <b-form-input
                      id="name"
                      v-model="itemData.channel_name"
                      disabled
                    />

                  </b-form-group>

                  <b-form-group
                    label="Thời gian bắt đầu"
                    label-for="begin_date"
                  >
                    <template #label>
                      <label class="d-block font-weight-bolder pb-0">Thời gian phát sóng<span class="text-danger">*</span></label>
                    </template>
                    <flat-pickr
                      v-model="itemData.broadcast_date"
                      class="form-control"
                      :config="configDate"
                      placeholder="dd-mm-yyyy"
                      disabled
                      theme="dark"
                    />
                  </b-form-group>

                  <b-form-group
                    label-for="manager_id"
                  >
                    <template #label>
                      <label class="d-block font-weight-bolder">Chương trình <span
                        class="text-danger"
                      >*</span></label>
                    </template>
                    <b-form-input
                      id="name"
                      v-model="itemData.program_name"
                      readonly
                    />

                  </b-form-group>
                </b-col>
              </b-col>

              <b-col
                md="12"
                class="row"
              >
                <!-- File -->

                <b-form-group>
                  <div class="attachedFiles">

                    <div class="fileupload">
                      <div class="d-flex">
                        <div class="mr-2">
                          <label class="d-block font-weight-bolder pb-0">Đính kèm</label>
                        </div>
                        <!-- <div>
                            <file-upload
                              ref="uploadAttach"
                              v-model="attachedFiles"
                              class="btn btn-blue btn-sm"
                              :post-action="api_upload"
                              :headers="custom_header"
                              :drop="true"
                              accept="image/*,application/*,audio/*,video/*"
                              :multiple="true"
                              input-id="attachedFiles"
                              :add-index="true"
                              :size="3000 * 1024 * 1024"
                              @input-file="inputFileAttach"
                            >
                              <feather-icon icon="UploadIcon" /> Upload từ máy tính </file-upload>
                          </div> -->
                      </div>
                    </div>
                    <div
                      v-if="attachedFiles.length > 0"
                      class="showData mt-1"
                    >
                      <table class="table table-striped">
                        <tbody>
                          <tr
                            v-for="(item, index) in attachedFiles"
                            :key="index"
                          >
                            <td
                              width="250"
                              @click="downloadfile(item)"
                            >
                              <p
                                class="mb-0 lineText"
                              >
                                <strong>{{ item.filename_original }}</strong>
                              </p>
                              <p
                                v-if="item.error"
                                class="text-danger fs_9 font-weight mb-0"
                              >{{ item.error }}</p>
                              <div v-else>
                                <p
                                  v-if="item.success || item.uploaded"
                                  class="size fs_9 font-weight mb-0"
                                >
                                  <span>{{ formatFileSize(item.size) }}</span>
                                </p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-form-group>

              </b-col>
            </b-col>

          </b-row>
        </b-form>
      </validation-observer>

    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback, BFormCheckbox, BFormTextarea, BCardText, BFormSelect,
} from 'bootstrap-vue'
import {
  ref, reactive,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNumDot, max,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'
import moment from 'moment'
import axios from 'axios';
import {
  defaultOptions, apiUpload, apiDownload,
} from '@/libs/initTinymce'

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BCardText,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    flatPickr,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    mdata: Object,
  },
  data() {
    return {
      required,
      alphaNumDot,
      max,

    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {
    formatFileSize(bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals || 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
    downloadfile(item) {
      axios
        .get(item.full_path ?? item.file_local, {
          headers: {
            Accept: item.mimetype,
          },
          responseType: 'blob',
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: item.mimetype })
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = item.name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          console.log(JSON.stringify(error))
        })
    },

    onUpdateAttachedFiles(file) {
      this.itemData.attached_files = file
    },
  },

  setup(props, { emit }) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const errorMessage = ref('')
    const attachedFiles = ref([])
    const defaultItemData = {
      name: '',
      description: '',
      repair_unit: '',
      data_field: [],
      series_ids: [],
    }
    const state = reactive({
      api_upload: apiUpload,
      api_download: apiDownload,
    })
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)));

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)
    const formatDate = (value) => moment(String(value)).format('DD-MM-YYYY')

    const onSubmit = () => {
      errorMessage.value = '';

      // if (itemData.value.id != null) {
      //   console.log(itemData);

      // } else {
      //   store.dispatch('device/createCategoryTypeDevice', itemData.value)
      //     .then((response) => {
      //       if (response.status === 200) {
      //         if (response.data.code === 200) {
      //           showToast(response.data.message, { variant: 'success' });
      //           resetForm()
      //           emit('updateData')
      //         } else {
      //           showToast(response.data.message)
      //           errorMessage.value = response.data.message;
      //         }
      //       }
      //     })
      // }
    }

    if (props.mdata) {
      // getOne();
      // dataSeries.value = props.mdata.details.map(o => ({
      //   name: o.series_name,
      //   id: o.series_id,
      // }));
      // itemData.value = props.mdata;
      // itemData.value.series_ids = props.mdata.details.map(o => o.series_id);
      itemData.value = props.mdata;
      attachedFiles.value = props.mdata.data_files ? props.mdata.data_files : []
    }

    const configDate = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    return {
      id,
      errorMessage,
      itemData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      configDate,
      attachedFiles,
    }
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
